import type { ComponentProps } from 'react';
import { memo } from 'react';
import { FormattedMessage } from 'react-intl';
import { QuantityInput } from '@library';

const NotAvailableMessage = memo(() => (
    <FormattedMessage id="Cart Error Item OutOfStock" />
));

const ProductQuantityControl = (
    props: ComponentProps<typeof QuantityInput>
) => {
    return (
        <QuantityInput {...props} zeroMaxMessage={<NotAvailableMessage />} />
    );
};

export default memo(ProductQuantityControl);
